module.exports = __webpack_public_path__ + "static/media/selo-ouro-de-inovacao.0552b82e.png";